<template>
    <div v-if="show" class="mt-6 mb-12 p-6 bg-primary-100 w-full text-blue-800 shadow-lg border border-blue-300">
        <div class="text-blue-600">
            <div class="flex justify-between">
                <h4 class="font-bold text-blue-600">{{ title }}</h4> 
                <div class="text-right">
                    <v-icon right @click="hideAlert()" light color="primary">fal fa-times-circle</v-icon>
                </div>
            </div>
            <p>
                <slot name="description">
                    A Virtual Data Centre allows you scale your vCPU, memory, and storage as you see fit, all powered by the latest hardware offerings from AMD and HPE.
                    You can provision servers, set up secure firewall rules &amp; VPN connections, configure private &amp; public networks, and schedule backups from a single control panel.
                </slot>
            </p>
            <slot name="features">
                <ul>
                    <li>High availability dual-zone platform</li>
                    <li>Scales with your business</li>
                    <li>Powerful networking options</li>
                    <li>Support for custom images</li>
                    <li>Powered by VMware vCloud Director</li>
                    <li>Secured by NSX-T</li>
                    <li>Bitnami Application Catalogue</li>
                    <li>Servers Australia holds the highest certification levels as a VMware Principle Partner & VMware Cloud Verified Provider</li>
                </ul>
            </slot>
        </div> 
        <div class="hover:bg-blue-200 border border-blue-600 w-auto">
            <a href="https://www.serversaustralia.com.au/products/virtual-data-centre" target="_blank" class="block no-underline py-2 px-3 text-blue-600 text-center" style="cursor: pointer;">{{ button }}</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Have you considered a Virtual Data Centre?'
        },
        button: {
            type: String,
            default: 'Learn More'
        },
        featureKey: {
            type: String,
            default: 'show-vdc-alert-box'
        }
    },
    data() {
        return {
            hide: false
        }
    },
    computed: {
        show() {
            if(!this.userFeatures || this.hide) return false; // prevent 'property of undefined' errors before the store has saved user details
            // If the user has selected to not show the notification, it will be have a feature entry 'start-conversations: hide'
            return this.userFeatures.hasOwnProperty(this.featureKey) ? false : true;
        },
    },
    methods: {
        hideAlert() {
            this.hide = true;
            const data = {
                key: this.featureKey,
                value: true,
                user_id: this.userDetails.id,
            };
            axios.post('/api/user-feature/update', data);
        }
    }
}
</script>